import { Avatar, Box, Typography } from '@mui/material';
import './GigReviewItem.scss';
import { Review } from '../../../../Models/Review';
import StarRating from '../../../CommonComponents/StarRating/StarRating';

interface GigReviewItemProps {
  review: Review;
}

const GigReviewItem = ({ review }: GigReviewItemProps) => {
  return (
    <Box className="gig-review-item">
      <Box className="review-header">
        <Avatar src={review.reviewer.profileImage} alt={review.reviewer.fullName} className="review-avatar" />
        <Box className="reviewer-info">
          <Typography className="reviewer-name">{review.reviewer.fullName}</Typography>
          <Typography className="review-time">
            {review.createdAt?.toLocaleDateString()}
          </Typography>
        </Box>
      </Box>

      <Box className="review-rating">
        <StarRating value={review.rating} disabled size={24} showRatingDescription = {false} />
      </Box>

      <Typography className="review-comment">{review.comment}</Typography>
    </Box>
  );
};

export default GigReviewItem;
